import React from 'react';
import { createRoot } from 'react-dom/client';
import SciFiShowPage from '../components/SciFiShowPage';
const projectContainer = document.getElementById('scifi-page');

if (projectContainer) {
  const root = createRoot(projectContainer);
  root.render(
    // <React.StrictMode> // Optional, good for development
      <SciFiShowPage />
    // </React.StrictMode>
  );
} else {
  console.error("Root element for SciFiShowPage (#scifi-page) not found. Check your Rails view.");
}